var _style, _polygon, _defs, _polygon2, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconsMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.2 9.6",
    style: {
      enableBackground: "new 0 0 13.2 9.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#405C40;}\r\n\t.st1{clip-path:url(#SVGID_00000088850436949913096170000010236685313307454391_);fill:#405C40;}\r\n\t.st2{clip-path:url(#SVGID_00000093135597615521006940000011373033285262258620_);fill:#405C40;}\r\n\t.st3{clip-path:url(#SVGID_00000086692276629003258510000016973047777610712723_);fill:#405C40;}\r\n\t.st4{clip-path:url(#SVGID_00000094600539765541563490000002840336169577677745_);fill:#405C40;}\r\n\t.st5{clip-path:url(#SVGID_00000020379507963720957520000011216816529517761723_);fill:#405C40;}\r\n\t.st6{fill:#CD2D40;}\r\n\t.st7{fill:#0D468F;}\r\n\t.st8{fill:#FFFFFF;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,8.5 3.9,5.3 0,2 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 13.2,
    height: 9.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034810483803103852210000006888111916674212489_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000034810483803103852210000006888111916674212489_)",
      fill: "#405C40"
    },
    d: "M12.1,0H1 C0.5,0,0.1,0.4,0,0.9l5.2,4.3L6,5.9c0.3,0.2,0.8,0.2,1.1,0L8,5.1l5.1-4.3C13.1,0.4,12.6,0,12.1,0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.2,5.3 13.2,8.5 13.2,2 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000062193742765467042120000007502595289725668738_",
    width: 13.2,
    height: 9.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077317109741372286890000002109349422130240668_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062193742765467042120000007502595289725668738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000077317109741372286890000002109349422130240668_)",
      fill: "#405C40"
    },
    d: "M7.8,6.5L7.1,7.1 C6.8,7.3,6.3,7.3,6,7.1L5.1,6.3L4.6,5.9L0.4,9.4C0.6,9.5,0.8,9.6,1,9.6h11.1c0.2,0,0.5-0.1,0.6-0.2L8.5,5.9L7.8,6.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconsMail);
export default __webpack_public_path__ + "static/media/InfoIcons_Mail.a3b3c1e9c9f6ad8de0624ddfbb84502c.svg";
export { ForwardRef as ReactComponent };